export enum DATA_QA {
  ROOT = 'csv-name-input',
  INPUT = 'csv-name-input__input',
}
